import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=28579572&scoped=true&lang=pug&"
import script from "./Story.vue?vue&type=script&lang=js&"
export * from "./Story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28579572",
  null
  
)

export default component.exports